import Icon from "@mdi/react";
import {mdiCamera, mdiCheck} from "@mdi/js";
import React, {useState, ChangeEvent} from "react";
import axios from "axios";
import General from "../constants/General";
import i18n from "../lang/i18n";
import {getFileName} from "../Helper";
import {TaskImageType} from "../types/Task";
import {useManageContext} from "../App";
import {ToastType} from "../types/General";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({text, section, number, filename, tripKey, taskKey, onSuccess, fileType, bgClass}: {
    text: string,
    section: string,
    number: string,
    filename: string,
    tripKey: string,
    taskKey: string,
    onSuccess: CallableFunction,
    fileType: TaskImageType,
    bgClass: string,
}) => {
    const [isSendingImage, setIsSendingImage] = useState(false);
    const {setToast} = useManageContext();

    const sendImageToEndpoint = async (event: ChangeEvent<HTMLInputElement> ) => {
        setIsSendingImage(true);

        if (event.target.files === null) {
            setIsSendingImage(false);

            return;
        }

        let formData = new FormData();
        formData.append('File', event.target.files[0], getFileName(filename, event.target.files[0].name));

        try {
            const {data} = await
            axios.post(`${General.apiUrl}/upload-file-section-number?TripKey=${tripKey}&Section=${section}&Number=${number}&TaskId=${taskKey}&FileType=${fileType}`,
            formData); if (data.Status === 1) { await onSuccess(fileType); setToast({ type: ToastType.Success,
            title: 'Done!', text: i18n.t('2604'), iconPath: mdiCheck, }); } else { window.alert(i18n.t('2605')); }
        } catch (error: any) {
            window.alert(i18n.t('2605'));
        }

        setIsSendingImage(false);
    };

    return (
        <label htmlFor={filename} className='w-100'>
            <div className={'border-0 p-3 text-center ' + (isSendingImage ? 'disabled ' : '') + bgClass}>
                {isSendingImage
                    ?
                    <div className={"spinner-border " + (bgClass !== 'bg-primary-container' ? 'text-light' : 'text-primary')} role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    :
                    <div>
                        <Icon className={(bgClass !== 'bg-primary-container' ? 'text-light' : 'text-primary')} path={mdiCamera} size={1.2}/>
                        <input multiple={false} onChange={sendImageToEndpoint} type="file" accept="image/*" id={filename} className='d-none'/>
                    </div>
                }
                <div className={'mb-0 fw-light fs-6 ' + (bgClass !== 'bg-primary-container' ? 'text-light' : 'text-primary')}>
                    <small style={{textDecoration: 'none'}}>{text}</small>
                </div>
            </div>
        </label>
    )
}

